import { Module, ScopeEnum } from 'src/domain';
import { useUnsavedChangesModule } from '../unsaved-changes/useUnsavedChangesModule';

export const useHasUnsavedChanges = (module?: Module, scope?: ScopeEnum, id?: string | number) => {
    const [unsavedChanges] = useUnsavedChangesModule(module, scope, id);
    return !!unsavedChanges;
};
